export default "__VITE_ASSET__3f92ae81__$_?inline__"